export const alphabetically = property => (a, b) => {
  const aProperty = a[property].toUpperCase();
  const bProperty = b[property].toUpperCase();
  if (aProperty < bProperty) {
    return -1;
  }
  if (aProperty > bProperty) {
    return 1;
  }
  return 0;
};
